import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingButtonDirective } from '@platform/components/buttons/loading-button/loading-button.directive';

@Component({
  selector: 'app-button-indicator',
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, TranslateModule, LoadingButtonDirective],
  template: `
    <button
      mat-icon-button
      color="primary"
      [attr.aria-label]="areaLabelT | translate"
      [matTooltip]="toolTipT | translate"
      [appLoadingButton]="isPending"
      (click)="this.clicked.emit(undefined)"
    >
      <mat-icon [svgIcon]="svgIcon" />
    </button>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIndicatorComponent {
  @Input() areaLabelT: string;
  @Input() toolTipT?: string;
  @Input({ required: true }) svgIcon: string;
  @Input() isPending: boolean;
  @Output() clicked = new EventEmitter<Event>();
}
